<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <div
      v-for="(note, index, i) in getCustomerNotes"
      :key="note"
      :class="getClassName + 'ValueContainer'"
    >
      <div :class="getClassName + 'Value'">
        {{ $t(note.label) }}
      </div>
      <input
        v-model="getCustomerNotesValues[index]"
        type="text"
        :placeholder="$t(note.placeholder ?? '')"
        :maxlength="note.text_length"
      />
    </div>
  </div>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useCustomerNotesStore } from "@/stores/modules/customerNotes";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useWebproductStore, ["getCustomerNotes"]),
    ...mapState(useCustomerNotesStore, ["getName", "getCustomerNotesValues"]),
    getActualName: function () {
      return this.getName;
    }
  }
};
</script>
